var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnfoldLess = function SvgUnfoldLess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.575 20L7.5 18.925L12 14.425L16.5 18.925L15.425 20L12 16.575L8.575 20ZM12 9.575L7.5 5.075L8.575 4L12 7.425L15.425 4L16.5 5.075L12 9.575Z",
    fill: "#000000"
  })));
};
export default SvgUnfoldLess;